{
  "fr": {
    "curriculum": {
      "confirmDelete": {
        "confirm": "Oui, supprimer",
        "text": "Voulez-vous vraiment supprimer \"{filename}\" ? Le fichier et son contenu de programme recherchable seront supprimes.",
        "title": "Supprimer le programme ?"
      },
      "configure": "Ouvrir les reglages du programme",
      "contextPanel": {
        "loadFailed": "Les programmes scolaires n'ont pas pu être chargés pour le moment. Réessaie plus tard.",
        "manage": "Gérer ses propres programmes scolaires",
        "matching": "Ces programmes scolaires correspondent aux données scolaires ci-dessus.",
        "noSubject": "Choisis une matière ci-dessus, nous t'afficherons les programmes scolaires correspondants.",
        "noSubjectMatch": "Nous n'avons pas de programme scolaire pour la matière sélectionnée. Télécharge le tien, l'IA l'utilisera alors.",
        "none": "Nous n'avons pas encore de programme scolaire pour ces données. Télécharge le tien, l'IA l'utilisera alors.",
        "notFound": "Pour les données ci-dessus, nous n'avons trouvé aucun programme scolaire adapté dans {place}. Télécharge le tien, l'IA l'utilisera alors.",
        "ownDocument": "document personnel",
        "title": "Programmes scolaires",
        "unknownRegion": "Nous ne connaissons pas ton Land. Pour éviter que l'IA n'utilise un mauvais programme scolaire, elle n'en utilisera aucun. Indique ton Land dans ton profil.",
        "used": "Ce matériel est basé sur ces programmes scolaires.",
        "usedIn": "Ce matériel est basé sur ces programmes scolaires pour {place}."
      },
      "coverage": {
        "grades": "Classe {range}",
        "heading": "Tes matières dans {place}",
        "headingWithoutPlace": "Tes matières",
        "openProfile": "Ouvrir le profil",
        "profileIncomplete": "Déposez vos matières, type d'école et niveaux de classe dans le profil, puis nous vous montrerons les programmes correspondants ici.",
        "unmapped": "Il n'existe pas de programme propre pour {labels}. Téléchargez le vôtre, puis l'IA l'utilisera.",
        "editProfile": "Modifier le profil",
        "own": "Propre",
        "none": "Aucun programme pour {place}",
        "noneOtherRegions": "Aucun programme pour {place}, uniquement pour d'autres Länder",
        "uploadHint": "Téléchargez le vôtre ci-dessous.",
        "more": "et {count} autres"
      },
      "delete": "Supprimer le programme",
      "deleted": "Le programme a ete supprime.",
      "deleteFailed": "Le programme n'a pas pu etre supprime.",
      "empty": "Aucun document de programme personnel n'a encore ete importe.",
      "fields": {
        "country": "Pays",
        "gradeLevel": "Niveau de classe",
        "region": "Region",
        "schoolType": "Type d'ecole",
        "subject": "Matiere",
        "title": "Titre"
      },
      "intro": "Nous utilisons les programmes officiels d'Allemagne, d'Autriche et de Suisse. Vous pouvez également télécharger vos propres documents de programme, par exemple un curriculum interne à l'école. Si un programme propre existe pour une matière, l'IA s'y réfère en premier.",
      "loading": "Chargement des programmes...",
      "notSet": "Non defini",
      "placeholders": {
        "selectOrAddOptions": "Rechercher, selectionner ou saisir une valeur"
      },
      "saved": "Metadonnees du programme enregistrees.",
      "title": "Programmes",
      "upload": "Importer un programme",
      "uploaded": "Le programme a ete importe et est en cours de traitement.",
      "uploadFailed": "Le programme n'a pas pu etre importe.",
      "library": {
        "title": "Programmes scolaires",
        "subtitle": "Que prévoit le programme pour ton cours ? Choisis le pays, le type d'école, la matière et le niveau scolaire ou cherche directement un thème.",
        "search": {
          "label": "Rechercher dans les programmes",
          "placeholder": "Rechercher un thème, un terme ou une compétence…",
          "submit": "Rechercher",
          "clear": "Terminer la recherche",
          "resultsTitle": "{count} résultat pour « {query} » | {count} résultats pour « {query} »",
          "noResultsTitle": "Aucun résultat pour « {query} »",
          "noResultsText": "Essaie un autre terme ou supprime les filtres de matière et de niveau.",
          "loadFailed": "La recherche n'a pas fonctionné. Veuillez réessayer.",
          "examplesLabel": "Par exemple :",
          "examples": "Évolution, écosystème, fonctions quadratiques, modèle particulaire, hormones"
        },
        "filters": {
          "country": "Pays",
          "region": "Land",
          "regionCh": "Canton",
          "allRegions": "Toutes les régions",
          "schoolType": "Type d'école",
          "allSchoolTypes": "Tous les types d'école",
          "subject": "Matière",
          "allSubjects": "Toutes les matières",
          "yourSubjects": "Tes matières",
          "otherSubjects": "Autres matières",
          "subjectSearch": "Rechercher une matière…",
          "noDocuments": "pas encore",
          "editProfile": "Modifier le profil",
          "fromProfileFrame": "Présélectionné depuis votre profil : {frame}."
        },
        "grades": {
          "title": "Niveau scolaire",
          "hint": "Les barres indiquent le nombre de programmes par niveau.",
          "selected": "Niveau {grade} uniquement",
          "showAll": "Tout afficher",
          "gradeLabel": "Niveau {grade}, {count} programme | Niveau {grade}, {count} programmes",
          "primary": "Primaire 1–4",
          "secondaryOne": "Secondaire I 5–10",
          "secondaryTwo": "Secondaire II 11–13",
          "short": "Niv."
        },
        "list": {
          "count": "{count} programme | {count} programmes",
          "read": "Lire",
          "loadFailed": "Les programmes n'ont pas pu être chargés. Veuillez réessayer."
        },
        "empty": {
          "regionTitle": "Nous n'avons pas encore de programmes pour {place}",
          "regionText": "Nous ajoutons progressivement tous les pays. Tu peux dès maintenant télécharger le programme de ton école dans le chat IA et l'utiliser.",
          "filterTitle": "Aucun programme pour cette sélection",
          "filterText": "Supprime un filtre ou choisis un autre niveau scolaire.",
          "unknownFilter": "Cette sélection nous est inconnue. Veuillez la refaire."
        },
        "reader": {
          "back": "Programmes scolaires",
          "original": "Ouvrir l'original",
          "contents": "Contenu",
          "find": "Rechercher dans ce programme…",
          "findLabel": "Rechercher dans ce programme",
          "matches": "{count} section | {count} sections",
          "otherGrades": "Dans d'autres niveaux :",
          "hours": "env. {hours} h",
          "verbatim": "Libellé du programme officiel",
          "lostTable": "L'original contient un tableau dont le contenu n'a pas pu être repris. Veuillez consulter l'original.",
          "notFound": "Ce programme n'existe pas ou n'existe plus.",
          "chapterTruncated": "Ce chapitre est très long et a été raccourci ici. Le texte complet se trouve dans l'original.",
          "textFailed": "Le texte de ce programme n'a pas pu être chargé. Rechargez la page pour réessayer.",
          "chapterFailed": "Ce chapitre n'a pas pu être chargé.",
          "retry": "Réessayer"
        }
      },
      "ownDocumentsHeading": "Vos propres programmes",
      "processing": "En cours de traitement… les catégories apparaîtront ici.",
      "ready": "Prêt",
      "failed": "Impossible de traiter.",
      "retry": "Réessayer",
      "retryFailed": "Le traitement n'a pas pu être redémarré."
    }
  }
}
